import { advertFormatCurrency } from "../utils";
// Compute the sale-badge content for a package, or null when there's no active
// time-limited discount to advertise. Shared by the desktop and mobile package
// cards so the two surfaces can't drift — in particular on how a null
// `rebateDisplay` is treated (Number(null) === 0 would otherwise show a
// percentage badge on mobile while desktop shows none).
//
// rebateDisplay: 0 = percentage, 1 = absolute amount saved, 2 = the discounted
// price itself. null/undefined or any other value → no badge.
export function packageDiscountBadge(pkg) {
    if (!pkg.useTimeLimitedDiscount) {
        return null;
    }
    const priceToPay = pkg.timeLimitedDiscountPrice;
    if (!pkg.originalPrice || pkg.originalPrice <= priceToPay) {
        return null;
    }
    if (pkg.rebateDisplay == null) {
        return null;
    }
    switch (pkg.rebateDisplay) {
        case 1: {
            // Absolute amount saved; drop decimals when it's a whole number.
            let diff = pkg.originalPrice - priceToPay;
            if (diff - Math.floor(diff) === 0) {
                diff = Math.trunc(diff);
            }
            return { kind: "save", value: advertFormatCurrency(diff) };
        }
        case 2:
            return { kind: "rightNow", value: advertFormatCurrency(priceToPay) };
        case 0: {
            const pct = Math.round(((pkg.originalPrice - priceToPay) / pkg.originalPrice) * 100);
            return { kind: "save", value: `${pct}%` };
        }
        default:
            return null;
    }
}
